var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5"},_vm._l((_vm.workflows),function(workflow){return _c('WorkflowNotification',{key:workflow.WorklowPK,attrs:{"workflow":workflow,"tenancy-pk":workflow.RelatedToFK,"type":"Property"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }